import { memo, useCallback, useMemo, useRef } from 'react';

import useOrderFilterValues from 'api/useOrderFilterValues';
import { usePaginationFromURL } from 'hooks/usePaginationFromURL';
import { encodeUrlArrayParam } from 'utils/queryParamsUtil';

import { FilterPopover } from 'components/FilterComponents/FilterPopover/FilterPopover';
import { FilterType } from 'components/FilterComponents/FilterPopover/types';

import { ordersUtils } from '../../../utils';
import { OrderFilterKey } from '../../constant';

interface DeviceOSFilterProps {
  selectedProjects: string;
  handleUpdateParam: (paramName: string, paramValue: string) => void;
}

export const DeviceOSFilter = memo(
  ({ selectedProjects, handleUpdateParam }: DeviceOSFilterProps) => {
    const { os: selectedOS } = usePaginationFromURL('orders');

    const { data: filterValues } = useOrderFilterValues(selectedProjects);

    const handleUpdateParamRef = useRef(handleUpdateParam);
    handleUpdateParamRef.current = handleUpdateParam;

    const filterOptions = useMemo(
      () =>
        Object.entries(filterValues?.displayOSGroups ?? {}).map(
          ([label, values]) => ({
            label,
            value: values.join(ordersUtils.STATUSES_SEPARATOR)
          })
        ),
      [filterValues?.displayOSGroups]
    );

    const handleSelectionChange = useCallback((selectedItems: string[]) => {
      handleUpdateParamRef.current(
        OrderFilterKey.OS,
        selectedItems.length ? encodeUrlArrayParam(selectedItems) : ''
      );
    }, []);

    return (
      <>
        {filterOptions?.length > 0 && (
          <FilterPopover
            label="Device OS"
            options={filterOptions}
            selectedItems={selectedOS}
            onSelectionChange={handleSelectionChange}
            filterType={FilterType.CHECKLIST}
            popoverHeight="auto"
          />
        )}
      </>
    );
  }
);

DeviceOSFilter.displayName = 'DeviceOSFilter';
